import React, { forwardRef } from "react";
import { bool, node, string } from "prop-types";

import * as S from "./styled";

const Fieldset = forwardRef(
  (
    { children, disabled, error, helper, hint, id, isValid, legend, ...props },
    ref
  ) => {
    const errorID = `${id}-errorText`;
    const helperID = `${id}-helperText`;
    const legendID = `${id}-legendText`;

    const ariaLabels = () => {
      let label = legendID;

      if (helper) label += ` ${helperID}`;

      if (error) label += ` ${errorID}`;

      return label;
    };

    return (
      <S.Fieldset
        ref={ref}
        aria-labelledby={ariaLabels()}
        disabled={disabled}
        {...props}
      >
        <S.Legend id={legendID}>
          {legend}
          {hint && <S.Hint>&nbsp;({hint})</S.Hint>}
        </S.Legend>
        {helper && (
          <S.Helper id={helperID} isVisuallyHidden={!isValid}>
            {helper}
          </S.Helper>
        )}
        {error && (
          <S.Error aria-live="assertive" id={errorID}>
            {!isValid && error}
          </S.Error>
        )}
        {children}
      </S.Fieldset>
    );
  }
);

Fieldset.displayName = "Fieldset";

Fieldset.propTypes = {
  children: node.isRequired,
  disabled: bool,
  error: string,
  helper: string,
  hint: string,
  id: string.isRequired,
  isValid: bool,
  legend: string.isRequired
};

Fieldset.defaultProps = {
  disabled: false,
  error: null,
  helper: null,
  hint: null,
  isValid: true
};

export default Fieldset;
